(() => {
  const instances = new Map();
  function init(scope = document) {
    scope.querySelectorAll('[data-search-form]').forEach(form => {
      if (instances.has(form)) return;
      const input = form.querySelector('[data-search-input]');
      const root = form.querySelector('[data-predictive]');
      const content = form.querySelector('[data-predictive-content]');
      const loading = form.querySelector('[data-predictive-loading]');
      if (!input || !root || !content || !loading) return;
      const events = new AbortController();
      const on = (node, type, fn) => node.addEventListener(type, fn, {signal:events.signal});
      let controller, timer, generation = 0;
      input.setAttribute('aria-expanded','false');
      root.id = 'Predictive-' + form.id;
      input.setAttribute('aria-controls',root.id);
      const hide = () => {
        generation++; clearTimeout(timer); controller?.abort();
        root.hidden = true; loading.hidden = true; content.innerHTML = '';
        input.setAttribute('aria-expanded','false');
      };
      const fetchResults = async term => {
        controller?.abort(); controller = new AbortController();
        const request = ++generation;
        loading.hidden = false; content.innerHTML = ''; root.hidden = false;
        input.setAttribute('aria-expanded','true');
        const url = (window.Shopify?.routes?.root || '/') + 'search/suggest?q=' + encodeURIComponent(term) + '&resources[type]=product,collection,query&resources[limit]=6&section_id=predictive-search';
        try {
          const response = await fetch(url,{signal:controller.signal});
          if (!response.ok) throw new Error('predictive-search');
          const text = await response.text();
          if(request !== generation || !form.isConnected) return;
          const html = new DOMParser().parseFromString(text,'text/html');
          content.innerHTML = html.querySelector('#shopify-section-predictive-search')?.innerHTML || '';
          loading.hidden = true;
          if(!content.textContent.trim()) hide();
        } catch(error) { if(error.name !== 'AbortError' && request === generation) hide(); }
      };
      on(input,'input',()=>{
        hide(); const term=input.value.trim();
        if(term.length>=2) timer=setTimeout(()=>fetchResults(term),180);
      });
      on(input,'focus',()=>{if(input.value.trim().length>=2 && root.hidden)timer=setTimeout(()=>fetchResults(input.value.trim()),180);});
      on(document,'click',event=>{if(!form.contains(event.target))hide();});
      on(form,'keydown',event=>{
        if(event.key==='Escape'){hide();input.focus();event.stopPropagation();}
        if(event.key==='ArrowDown' && event.target===input && !root.hidden){const link=content.querySelector('a');if(link){event.preventDefault();link.focus();}}
      });
      on(form,'focusout',event=>{if(!form.contains(event.relatedTarget))hide();});
      instances.set(form,()=>{hide();events.abort();});
    });
  }
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    for(const [form,dispose] of instances)if(event.target.contains(form)){dispose();instances.delete(form);}
  });
})();
